/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.2.0",
  "gitBuildTime": "2026-03-25T17:41:50.587Z",
  "gitBuildVersion": "2.2.0",
  "gitCommitId": "14ff0df",
  "gitCommitIdFull": "14ff0dfe6978829367bbb6e015ceb9cfd3fa7730",
  "gitCommitTime": "2026-03-25T17:40:06.000Z",
  "version": "2.2.0-2026-03-25T17:40:06.000Z-(14ff0df)"
};
